<!--
    * @Description: 白皮书下载
    * @Date: 2024-06-28
    * @filePath: Do not edit
   -->
<template>
    <div class="feedback paper-modal">
        <div class="modal fade" id="whitePaperModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div id="my_whitePaper_load" style="display: none; z-index: 1055;">
                        <div class="modal_load_div d-flex justify-content-center align-items-center">
                            <div class="spinner-border modal_load" role="status"></div>
                        </div>
                    </div>
                    <div class="modal-header">
                        <h1 class="modal-title title">白皮书下载</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <p class="modal_tip">提交信息后，浏览器将自动下载白皮书，请不要关闭此页面</p>
                    <input type="hidden" id="whitePaperModal_ID" value="" />
                    <div class="modal-body modal-dialog-scrollable">
                        <form class="formData" id="paper_formData">
                            <div class="form-content">
                                <input type="text" id="paper_FullName" v-model="form.FullName" name="FullName"
                                    maxlength="100" :placeholder="$t('feedback.form.form_fullname')"
                                    @blur="handleOperate('paper_FullName')" @change="handleOperate('paper_FullName')" />
                            </div>
                            <div class="form-content">
                                <input type="text" id="paper_CompanyName" v-model="form.CompanyName" name="CompanyName"
                                    maxlength="200" :placeholder="$t('feedback.form.form_companyName')"
                                    @blur="handleOperate('paper_CompanyName')"
                                    @change="handleOperate('paper_CompanyName')" />
                                <div class="company-err"></div>
                            </div>
                            <div class="form-content form_input captcha">
                                <input type="tel" id="paper_Telephone" v-model="form.Telephone" name="Telephone"
                                    maxlength="100" placeholder="手机号码(必填)" @blur="handleOperate('paper_Telephone')"
                                    @change="handleOperate('paper_Telephone')" />
                                <div id="paper_telephoneMsg" class="pop-tips">
                                    *输入的手机号码格式不正确
                                </div>
                            </div>
                            <div class="combination">
                                <div class="form-content form_input SmsCode pr--15">
                                    <input type="text" id="paper_SmsCode" v-model="form.SmsCode" name="SmsCode"
                                        placeholder="验证码(必填)" @blur="handleOperate('paper_SmsCode')"
                                        @change="handleOperate('paper_SmsCode')" />
                                </div>
                                <div class="form-content form_input pl--15">
                                    <button id="paper_sendCode" type="button" class="form_btn whitePaper_code_btn"
                                        @click="handleCode">发送验证码</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="form-content" id="paper_pop-btn">
                        <button type="button" class="form_btn whitePaper_btn" id="paper_popBtn" @click="submitForm">
                            {{ $t('feedback.form.form_btn') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 显示toast -->
        <div aria-live="polite" aria-atomic="true"
            class="d-flex justify-content-end align-items-center p-3 w-100 feedback_toast" style="z-index: 1056;">
            <div id="my_whitePaper_toast" class="toast" role="alert" aria-live="assertive" aria-atomic="true"
                data-bs-delay="3000">
                <div class="d-flex">
                    <div class="toast-body text_color">{{ toastInfo }}</div>
                    <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal, Toast } from 'bootstrap'
import { paperCode, paperDownload } from '@/helpers/api'

export default {
    name: 'WhitePaper',
    props: {},
    components: {},
    data() {
        return {
            bsModal: null,
            codeFlag: false, // 加载验证码标识
            form: {},
            toastInfo: ''
        }
    },
    created() {
    },
    mounted() {
        this.bsModal = new Modal('#whitePaperModal')
        const myModalEl = document.getElementById('whitePaperModal')
        myModalEl.addEventListener('hide.bs.modal', event => {
            this.clearData()
        })
        myModalEl.addEventListener('show.bs.modal', event => {
            this.codeFlag = true
        })
    },

    methods: {
        //
        handleOperate(id) {
            let val = ''
            val = document.getElementById(id)
            val.value === '' ? val.classList.add('selected') : val.classList.remove('selected')
            if (id === 'paper_Telephone') {
                // 验证手机号码格式
                let regEmail = /^1[3-9]\d{9}$/
                !val.value ? document.getElementById('paper_telephoneMsg').classList.remove('dn') : regEmail.test(val.value) === true ? document.getElementById('paper_telephoneMsg').classList.remove('dn') : document.getElementById('paper_telephoneMsg').classList.add('dn')
            }
        },
        // 清空数据及样式
        clearData() {
            this.codeFlag = false
            this.form = {}
            document.getElementById('paper_FullName').classList.remove('selected')
            document.getElementById('paper_Telephone').classList.remove('selected')
            document.getElementById('paper_CompanyName').classList.remove('selected')
            document.getElementById('paper_SmsCode').classList.remove('selected')
        },
        // 获取验证码
        handleCode() {
            // 校验手机号是否为null
            const phone = document.getElementById('paper_Telephone')
            if (!this.form.Telephone) {
                phone.classList.add('selected')
                this.successToast('请先填写手机号码！')
                return
            }
            var btn = document.getElementById("paper_sendCode"); //获取验证码按钮
            var time = 59;
            // 禁用按钮
            btn.disabled = true;
            btn.classList.add("_disabled") // 添加禁用样式
            const data = `User=${this.form.Telephone}&type=GetFile&lang=${this.$i18n.locale}`
            paperCode(data)
                .then((res) => {
                    if (res.state == "success") {
                        // 开启定时器
                        var timer = setInterval(function () {
                            // 判断剩余秒数
                            if (time == 0) {
                                // 清除定时器和复原按钮
                                clearInterval(timer);
                                btn.disabled = false;
                                btn.classList.remove("_disabled") // 移除禁用样式
                                btn.innerHTML = '发送验证码';
                            } else {
                                btn.innerHTML = `${time} s`;
                                time--;
                            }
                        }, 1000);
                    }
                });
        },
        // 提交
        submitForm() {
            let FullName = document.getElementById('paper_FullName') // 姓名
            let CompanyName = document.getElementById('paper_CompanyName') // 公司全称
            let Telephone = document.getElementById('paper_Telephone') // 联系电话
            let SmsCode = document.getElementById('paper_SmsCode') // 验证码
            let sign = true
            // 必填字段：姓名、联系电话、公司全称、验证码
            if (!this.form.FullName || !this.form.Telephone || !this.form.CompanyName || !this.form.SmsCode) {
                sign = false
                !this.form.FullName ? FullName.classList.add('selected') : FullName.classList.remove('selected')
                !this.form.Telephone ? Telephone.classList.add('selected') : Telephone.classList.remove('selected')
                !this.form.CompanyName ? CompanyName.classList.add('selected') : CompanyName.classList.remove('selected')
                !this.form.SmsCode ? SmsCode.classList.add('selected') : SmsCode.classList.remove('selected')
            }
            if (sign === true) {
                document.getElementById('my_whitePaper_load').removeAttribute("style") // 开始loading
                // 下载白皮书
                // 获取白皮书id
                const myModalEl = document.getElementById('whitePaperModal_ID')
                const whitePaperData = JSON.parse(myModalEl.value)
                let data = `Id=${whitePaperData.id}&Fullname=${this.form.FullName ?? ''}&Telephone=${this.form.Telephone ?? ''}&CompanyName=${this.form.CompanyName ?? ''}&SmsCode=${this.form.SmsCode ?? ''}`
                paperDownload(data)
                    .then((res) => {
                        document.getElementById('my_whitePaper_load').style.display = "none" // 结束loading
                        if (res?.state == 'error') {
                            this.successToast(res.msg)
                            return
                        }
                        // 处理二进制数据并创建 Blob 对象
                        const blobObj = new Blob([res], { type: 'application/pdf' })
                        // 创建一个链接并设置下载属性
                        const downloadLink = document.createElement('a')
                        let url = window.URL || window.webkitURL || window.moxURL // 兼容不同浏览器的 URL 对象
                        url = url.createObjectURL(blobObj)
                        downloadLink.href = url
                        downloadLink.download = whitePaperData.title // 设置下载的文件名
                        // 将链接添加到 DOM 中，模拟点击
                        document.body.appendChild(downloadLink)
                        downloadLink.click()
                        // 移除创建的链接和释放 URL 对象
                        document.body.removeChild(downloadLink)
                        window.URL.revokeObjectURL(url)
                        // 模态框取消
                        var myModal = document.getElementById('whitePaperModal')
                        this.bsModal.hide(myModal)
                        this.successToast('白皮书下载成功！')
                    })
                    .catch(err => {
                        this.successToast('白皮书下载失败，请稍后再试！')
                    });
            }
        },
        // 提交成功提示
        successToast(msg) {
            var toastElList = [].slice.call(document.querySelectorAll('#my_whitePaper_toast'))
            var toastList = toastElList.map(function (toastEl) {
                return new Toast(toastEl)
            })
            this.toastInfo = msg
            toastList.forEach(toast => toast.show())
        }
    }

}
</script>